// Espelho do JSON de Empresa no CoreAPI (ZC-89): o ActionsForm casa form ↔ data pela chave.
export default {
  id: null,
  nome: null,
  nomeFantasia: null,
  cnpj: null,
  ie: null,
  codigoZ: null,
  localidade: null,
  descricao: null,
  selecionavel: null,
  logo: null,
  perfilAcessoID: null,
  percLimiteDespesa: null,
  theme: null,
  status: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/companymodel.js